import { colors, colorSystem } from '@/styles/theme'
import { HStack, Icon, VStack } from '@musinsa/mwms-ds'
import styled, { css } from 'styled-components'
import Text from '@/components/content/Text'
import useModal from '@/hooks/useModal'
import { Capacity } from '@/services/capacity/types'
import { SetCapacityModal } from './SetCapacityModal'
import { Suspense } from 'react'
import { BaseCell } from '../shared/BaseCell'
import { CELL_WIDTH } from '../OutboundTable'
import { CapaCell } from './CapaCell'
import { useCutOffDate } from '../../hooks/useCutOffDate'
import { DATE_FORMAT } from '@/utils/consts'
import dayjs from 'dayjs'

interface Props {
  warehouseCode: string
  warehouseName: string
  capacities: Capacity[]
}

export function CapaItem({ warehouseCode, warehouseName, capacities }: Props) {
  const { cutOffDate } = useCutOffDate()
  const isCutOffDateToday = dayjs().format(DATE_FORMAT.date) === cutOffDate

  const setCapacityModal = useModal()

  const b2bCapacity = capacities.find((c) => c.capacityType === 'B2B')
  const b2cCapacity = capacities.find((c) => c.capacityType === 'B2C')

  const isOperation = !!(b2cCapacity || b2bCapacity)
  const isUnlimited = b2cCapacity?.isUnlimited || b2bCapacity?.isUnlimited

  return (
    <>
      <VStack style={{ minWidth: CELL_WIDTH }}>
        <WarehouseCell
          $clickable={isCutOffDateToday && isOperation}
          onClick={() => {
            if (!isOperation) return
            setCapacityModal.onOpenModal()
          }}
        >
          <HStack gap={4} align="center">
            <Circle $color={isOperation ? colors.blue500 : colors.gray500} />
            <Text kind="Body_14_medium" color={isOperation ? colorSystem.text.table.cell : colorSystem.text.common.disabled}>
              {warehouseName}
            </Text>
          </HStack>
          {/* true 무한, false 제한 */}
          {isUnlimited && (
            <Tag className="tag">
              <Text kind="Body_12_regular">무한</Text>
            </Tag>
          )}
          <Icon className="setting-icon" name="setting" size={16} color="gray500" />
        </WarehouseCell>

        {b2cCapacity ? <CapaCell data={b2cCapacity} warehouseCode={warehouseCode} warehouseName={warehouseName} /> : <NotOperationCell />}
        {b2bCapacity ? <CapaCell data={b2bCapacity} warehouseCode={warehouseCode} warehouseName={warehouseName} /> : <NotOperationCell />}
      </VStack>

      {setCapacityModal.open && (
        <Suspense fallback={null}>
          <SetCapacityModal warehouseCode={warehouseCode} onClose={setCapacityModal.onCloseModal} />
        </Suspense>
      )}
    </>
  )
}

function NotOperationCell() {
  return (
    <BaseCell style={{ flex: 1, justifyContent: 'center', alignContent: 'center', background: colors.gray050 }}>
      <Text kind="Body_12_regular" color={colorSystem.text.common.tertiary}>
        미운영
      </Text>
    </BaseCell>
  )
}

const WarehouseCell = styled(BaseCell)<{ $clickable: boolean }>`
  height: 44px;
  border-bottom: 1px solid ${colors.gray400};

  justify-content: space-between;

  .setting-icon {
    display: none;
  }

  ${({ $clickable }) =>
    $clickable &&
    css`
      cursor: pointer;

      &:hover {
        .setting-icon {
          display: block;
        }
        .tag {
          display: none;
        }
      }
    `}
`

const Tag = styled.div`
  border-radius: 4px;
  border: 1px solid ${colorSystem.border.element};
  padding: 0px 4px;
`

const Circle = styled.div<{ $color: string }>`
  width: 6px;
  height: 6px;
  border-radius: 99%;
  background-color: ${({ $color }) => $color};
`
